var ApplicationAPI = require("../../../common/api").Application;
var ApplicantAPI = require("../../../common/api").Applicant;
var ReportAPI = require("../../../common/api").Report;

module.exports = function($scope, $state, ngDialog) {
  var vm = this;
  vm.loading = false;
  vm.list = [];
  vm.newApplicationDescription = "Start a new application for funding. You will be able to apply directly to a trust fund or the general public or look for funders who match you application criteria.";
  $scope.create = function() {
    var dialog = ngDialog.open({
      template: require("./dialogs/begin-application.pug")(),
      controller: require("./dialogs/begin-application.js"),
      controllerAs: "vm",
      plain: true,
      className: "ge-dialog-medium ngdialog-theme-default",
      disableAnimation: true,
    });

    dialog.closePromise.then(function(data) {
      if (data.value && data.value != "$document" && data.value != "$closeButton") {
        ApplicationAPI.Begin($scope.applicant.id, data.value.projectTitle, data.value.seekingPublicFunding, data.value.seekingTrustFunding, data.value.specificTrustForFundingId, data.value.specificSchemeUnderTrustId).then(function(resp) {
          $state.go("applicant.application", { id: resp });
        });
      }
    });
  };

  vm.goToApplication = function(app) {

    if (app.status.id == 1) {
      // edit requested status
      ngDialog.openConfirm({
        template: "\
                  <p>Your application edit request is currently pending approval.</p>\
                  <p>The application will not be editable until approved.</p>\
                  <div class=\"ngdialog-buttons clearfix\">\
                      <button type=\"button\" class=\"btn btn-danger btn-sm pull-xs-right m-l-1\" ng-click=\"closeThisDialog(0)\">Close</button>\
                      <button type=\"button\" class=\"btn btn-green btn-sm pull-xs-right\" ng-click=\"confirm(1)\">View</button>\
                  </div>",
        plain: true,
        disableAnimation: true
      })
      .then(function() {
        $state.go("applicant.application", { id: app.id });
      });

    } else {
      $state.go("applicant.application", { id: app.id });
    }
  };

  vm.getApplications = function() {

    vm.loading = true;

    return ApplicationAPI.GetApplications(vm.searchText).then(function(resp) {
      var items = [];
      resp.forEach(function(item){
        if (item.status.id <= 15) {
          items.push(item)
        }
      })
      vm.list = items;
    })
    .finally(function() {
      vm.loading = false;
    });
  };
  $scope.getApplicant = function() {
    ApplicantAPI.GetOwnApplicant("ApplicantDropdownView").then(function(result) {
      $scope.applicant = result;
    });
  };
  vm.showHideFunders = function(app) {
    app.showFunders = !app.showFunders;
  };

  function init() {
    vm.getApplications();
    ReportAPI.GetReportsByType(7).then(function(results){
      vm.applicationReports = results;
    });
    $scope.getApplicant();
  }

  init();
};
